import {
  Box,
  MenuDivider,
  MenuItem,
  MenuList,
  Stack,
  Text,
} from "@chakra-ui/react";
import { usePremiumRoutes } from "@ui/utils";
import { signOut } from "next-auth/react";
import { FaSignOutAlt } from "react-icons/fa";
import { MdSupport } from "react-icons/md";
import { PremiumMenuProps } from "./menu";

export const PremiumMenuList = (props: PremiumMenuProps) => {
  const { router, user } = usePremiumRoutes();
  return (
    <MenuList shadow="lg" py="4" px="3">
      <Stack flexDirection="row" pb="4" px="0.8rem">
        <Stack spacing="1">
          <Text fontSize="sm">{props?.name || user?.name}</Text>
          <Text fontSize="xs" color="subtle">
            {user?.email}
          </Text>
        </Stack>
      </Stack>
      {props.routes.map((route) => (
        <MenuItem
          key={route.href}
          icon={<Box as={route.icon} />}
          rounded="md"
          onClick={() => router.push(route.href)}
        >
          {route.label}
        </MenuItem>
      ))}
      <MenuDivider />
      <MenuItem
        icon={<FaSignOutAlt />}
        rounded="md"
        onClick={() => signOut({ callbackUrl: "signOut" })}
      >
        Log Out
      </MenuItem>
      <MenuItem
        icon={<MdSupport />}
        rounded="md"
        onClick={() => router.push("/support")}
      >
        Support
      </MenuItem>
    </MenuList>
  );
};
